import { Stack } from '@mui/material';
import Alert from '/@/components/bayer/alert';
import { useCapabilities } from '/@/hooks/session';
import { _ } from '/@/locale';
import type { Field } from '/@/types/field';
import FieldSelectMainContent from './field-select-main-content';
import FieldSelectModals from './field-select-modals';
import FieldSelectTabs from './field-select-tabs';
import FieldSelectToolbar from './field-select-toolbar';
import { useFieldSelect } from './use-field-select';

function FieldSelect({
    field,
    setField,
    polygonFilter,
    selectedProduct,
    soilMoisture,
    plantingDate,
    growersOnly,
}: {
    field: Field | undefined;
    setField: (field: Field | undefined) => void;
    polygonFilter?: boolean;
    selectedProduct?: number;
    soilMoisture?: number;
    plantingDate?: string;
    growersOnly?: boolean;
}) {
    const state = useFieldSelect({ field, setField, polygonFilter, selectedProduct, soilMoisture, plantingDate });
    const { canManageGrowers } = useCapabilities();

    return (
        <Stack spacing={3}>
            {polygonFilter && (
                <Alert severity='surfaceVariant'>
                    {_(
                        'N-Smart solo funciona con lotes creados con “Dibujar un polígono”. Los lotes creados con “Marcar un punto” no son válidos.'
                    )}
                </Alert>
            )}
            {state.includeChildrenNodes && canManageGrowers && !growersOnly && (
                <FieldSelectTabs tab={state.tab} setTab={state.setTab} />
            )}
            <FieldSelectToolbar
                fieldName={state.fieldName}
                setFieldName={state.setFieldName}
                debouncedFieldName={state.debouncedFieldName}
                fieldList={state.fieldList}
                showGrowersFields={state.showGrowersFields}
                growersQuery={state.growersQuery}
                selectedUserNodeId={state.selectedUserNodeId}
                setSelectedUserNodeId={state.setSelectedUserNodeId}
                hasNoGrowers={state.hasNoGrowers}
                ownNodeQuery={state.ownNodeQuery}
                setNewFieldModalOpen={state.setNewFieldModalOpen}
                isMobile={state.isMobile}
            />
            <FieldSelectMainContent {...state} />
            <FieldSelectModals {...state} />
        </Stack>
    );
}

export default FieldSelect;
